import React from 'react'
import * as microConfig from '@/views/micro/config'
import useGlobalThemeStore from '@/store/globalTheme'

/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event' // 必须声明，micro内部在使用jsxCustomEvent
import useMicroConfig from '@/hooks/useMicroConfig'

const RoleManage: React.FC = () => {
  const { theme } = useGlobalThemeStore()
  const { microUrl } = useMicroConfig()
  return (
    <>
      {microUrl && (
        <micro-app
          name={microConfig.MICRO_APPS[0].name}
          url={microUrl}
          defaultPage={microConfig.BASE_ROUTE.roleList}
          data={{
            theme
          }}
        />
      )}
    </>
  )
}

export default RoleManage
